import '../../../assets/icons/closed.svg';
import '../../../assets/icons/dropdown-arrow.svg';
